import { AdminAllowanceNames, ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import strings from '../../../localization';
import { nameLabels } from '../../../helpers/Constants';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

export const config = () =>
  (isSelfService
    ? [
      {
        key: '1',
        name: AdminAllowanceNames.pharmacistHourlyRate,
        label: strings.pharmacistHourlyRate,
      },

    ]
    : [
      {
        key: '1',
        name: AdminAllowanceNames.pharmacistHourlyRate,
        label: strings.pharmacistHourlyRate,
      },
      {
        key: '2',
        name: AdminAllowanceNames.pharmacyHourlyRate,
        label: strings.pharmacyHourlyRate,
      },
    ]);

export const checkboxConfig = () =>
  [
    {
      key: '1',
      name: 'sendEmailToPharmacist',
      label: strings.formatString(
        strings.sendEmailNotification,
        nameLabels().roleLabel,
      ) as string,
    },
    {
      key: '2',
      name: 'sendEmailToPharmacy',
      label: strings.formatString(
        strings.sendEmailNotification,
        strings.pharmacy,
      ) as string,
    },
  ];

export const notesConfig = () =>
  (isSelfService
    ? [
      {
        key: '2',
        name: 'notes',
        label: strings.notes,
      },
    ]
    : [
      {
        key: '1',
        name: 'notesForSalesOrder',
        label: strings.notesForSalesOrder,
      },
      {
        key: '2',
        name: 'notes',
        label: strings.notes,
      },
    ]);
